module.exports = __webpack_public_path__ + "img/ccf-zh-CN.3e1ea282.png";